// import libs
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  small: {
    width: theme.spacing(2),
    height: theme.spacing(2),
  },
  medium: {
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  brick: {
    backgroundColor: '#CC3D3F',
  },
  lightBlue: {
    color: '#000000de',
    backgroundColor: '#9DD3DE',
  },
}));

const AvatarNumberAndText = props => {
  const classes = useStyles();
  const { type, data, size, shape, color } = props;

  return (
    <div className={classes.root}>
      {((type === 'number' && data > 0) ||
        (type === 'text' && data !== undefined)) && (
        <Avatar
          variant={shape}
          className={`${classes[size]} ${classes[color]}`}
        >
          {data}
        </Avatar>
      )}
    </div>
  );
};

export default AvatarNumberAndText;



// WEBPACK FOOTER //
// ./src/views/components/Common/Table/CellRendererComponents/Avatar/AvatarNumberAndText.jsx